// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"s4-z","dimensionLabel":"t4-z","styleChooserControlWrapper":"u4-z","styleChooserControl":"v4-z","disabled":"w4-z","giftCard":"x4-z","styleChooserText":"y4-z"};